import {get, post} from '../router/http.js'


export default {
	login :(params) => {
		return post('/api/login', params)
	},
}



// WEBPACK FOOTER //
// ./src/api/login.js